import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSectionGrid = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	viewBox: "0 0 37.378 29.509",
	fill: "currentColor",
	stroke: "currentColor",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		id: "Rutenettseksjon",
		d: "M100,289.639V276h37.378v13.638Zm13.54,15.87V291.871h23.838V305.51Zm-13.54,0V291.871h11.308V305.51Z",
		transform: "translate(-100.001 -276.001)"
	})
});
export default SvgSectionGrid;
